import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";

const controller = rpcController("RepSaldosCart");

/**Resource del reporte de guias documentadas y del inventario de sucursal */
export const RepSaldoCartera = cacheResource({
    GenerarSaldosCart: async (parametros: models.FiltroReporteSaldosCart): Promise<string> => await controller("GenerarSaldosCart", {}, parametros),
    GenerarNotasCredito: async (parametros: models.FiltroReporteSaldosCart): Promise<string> => await controller("GenerarNotasCredito", {}, parametros),
    GenerarNotasCargo: async (parametros: models.FiltroReporteSaldosCart): Promise<string> => await controller("GenerarNotasCargo", {}, parametros)
}, {
    }, {

    })


// WEBPACK FOOTER //
// ./app/resources/items/repsaldoscart.tsx